import { arrayToMap, arrayToCategorizedMapWithMultipleKeys } from "../util";

export const path = "/master/common";

export const injects = ['line']

export const handler = (data, masterData) => {
  return {
    list: data.stations,
    byLine: arrayToCategorizedMapWithMultipleKeys(data.stations, "lines"),    
    byId: arrayToMap(data.stations, "stationId"),
  };
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/station.js